<template>
  <div class="hello">
    <div class="helloTop">
      <div class="helloTopOne">行业方案</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="oneTwo">
      <el-tab-pane label="教育行业" name="1" class="one_a boss_a animate__animated animate__bounceInLeft">
        <div v-if="activeName == 1" class="one_b animate__animated animate__bounceInRight">
          <div class="one_c">
            <div class="one_hh">
              <div
                v-for="(item, i) in items2"
                :key="i"
                :class="['one_d', hhh == i ? 'active' : '']"
                @click="qiehuanTop(i)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="one_ok"   @click="isOpen = !isOpen" >立即获取</div>
          </div>
          <div class="one_e " >
            <div class="one_f">
              <div class="one_the">{{ items2[hhh].title }}</div>
              <div
                v-for="(iteme, j) in items2[hhh].conments"
                :key="j"
                class="one_g animate__animated animate__bounceInUp"
              >
                <img src="../assets/HelloWorld/xiaoyuanqiu_1.png" alt="" />
                <div>{{ iteme }}</div>
              </div>
              <a href="/light">
                <div class="boss_1">
                  <div>了解更多</div>
                  <i class="el-icon-arrow-right" style="font-size: 20px;"></i>
                  <!-- <img src="../assets/HelloWorld//tubiao/67.png" alt=""> -->
                </div>
              </a>
            </div>
          </div>
        </div>
        <!-- <panel :panelList="items1"/> -->
      </el-tab-pane>
      <el-tab-pane label="汽车行业" name="2" class="one_a boss_b animate__animated animate__bounceInLeft">
        <div v-if="activeName == 2" class="one_b animate__animated animate__bounceInRight">
          <div class="one_c">
            <div class="one_hh">
              <div
                v-for="(item, i) in items3"
                :key="i"
                :class="['one_d', hhh == i ? 'active' : '']"
                @click="qiehuanTop(i)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="one_ok"   @click="isOpen = !isOpen" >立即获取</div>
          </div>
          <div class="one_e">
            <div class="one_f">
              <div class="one_the">{{ items3[hhh].title }}</div>
              <div
                v-for="(iteme, j) in items3[hhh].conments"
                :key="j"
                class="one_g animate__animated animate__bounceInUp"
              >
                <img src="../assets/HelloWorld/xiaoyuanqiu_1.png" alt="" />
                <div>{{ iteme }}</div>
              </div>
       <a href="/projectA">
                <div class="boss_1">
                  <div>了解更多</div>
                  <i class="el-icon-arrow-right" style="font-size: 20px;"></i>

                </div>
              </a>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="零售快消" name="3" class="one_a boss_c animate__animated animate__bounceInLeft">
        <div v-if="activeName == 3" class="one_b animate__animated animate__bounceInRight">
          <div class="one_c">
            <div class="one_hh">
              <div
                v-for="(item, i) in items4"
                :key="i"
                :class="['one_d', hhh == i ? 'active' : '']"
                @click="qiehuanTop(i)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="one_ok"   @click="isOpen = !isOpen" >立即获取</div>
          </div>
          <div class="one_e">
            <div class="one_f">
              <div class="one_the">{{ items4[hhh].title }}</div>
              <div
                v-for="(iteme, j) in items4[hhh].conments"
                :key="j"
                class="one_g animate__animated animate__bounceInUp"
              >
                <img src="../assets/HelloWorld/xiaoyuanqiu_1.png" alt="" />
                <div>{{ iteme }}</div>
              </div>
       <a href="/projectB">
                <div class="boss_1">
                  <div>了解更多</div>
                  <i class="el-icon-arrow-right" style="font-size: 20px;"></i>

                </div>
              </a>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="金融行业" name="4" class="one_a boss_d animate__animated animate__bounceInLeft">
        <div v-if="activeName == 4" class="one_b animate__animated animate__bounceInRight">
          <div class="one_c">
            <div class="one_hh">
              <div
                v-for="(item, i) in items5"
                :key="i"
                :class="['one_d', hhh == i ? 'active' : '']"
                @click="qiehuanTop(i)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="one_ok"   @click="isOpen = !isOpen" >立即获取</div>
          </div>
          <div class="one_e">
            <div class="one_f">
              <div class="one_the">{{ items5[hhh].title }}</div>
              <div
                v-for="(iteme, j) in items5[hhh].conments"
                :key="j"
                class="one_g animate__animated animate__bounceInUp"
              >
                <img src="../assets/HelloWorld/xiaoyuanqiu_1.png" alt="" />
                <div>{{ iteme }}</div>
              </div>
       <a href="/projectC">
                <div class="boss_1">
                  <div>了解更多</div>
                  <i class="el-icon-arrow-right" style="font-size: 20px;"></i>

                </div>
              </a>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="健康行业" name="5" class="one_a boss_e animate__animated animate__bounceInLeft">
        <div v-if="activeName == 5" class="one_b animate__animated animate__bounceInRight">
          <div class="one_c">
            <div class="one_hh">
              <div
                v-for="(item, i) in items6"
                :key="i"
                :class="['one_d', hhh == i ? 'active' : '']"
                @click="qiehuanTop(i)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="one_ok"   @click="isOpen = !isOpen" >立即获取</div>
          </div>
          <div class="one_e">
            <div class="one_f">
              <div class="one_the">{{ items6[hhh].title }}</div>
              <div
                v-for="(iteme, j) in items6[hhh].conments"
                :key="j"
                class="one_g animate__animated animate__bounceInUp"
              >
                <img src="../assets/HelloWorld/xiaoyuanqiu_1.png" alt="" />
                <div>{{ iteme }}</div>
              </div>
       <a href="/projectD">
                <div class="boss_1">
                  <div>了解更多</div>
                  <i class="el-icon-arrow-right" style="font-size: 20px;"></i>

                </div>
              </a>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="家电行业" name="6" class="one_a boss_f animate__animated animate__bounceInLeft">
        <div v-if="activeName == 6" class="one_b animate__animated animate__bounceInRight">
          <div class="one_c">
            <div class="one_hh">
              <div
                v-for="(item, i) in items7"
                :key="i"
                :class="['one_d', hhh == i ? 'active' : '']"
                @click="qiehuanTop(i)"
              >
                {{ item.title }}
              </div>
            </div>
          <!-- <div class="one_ok"   @click="isOpen = !isOpen"> <a href="/projectE">立即获取</a></div> -->
          <div class="one_ok"   @click="isOpen = !isOpen" >立即获取</div>
          </div>
          <div class="one_e">
            <div class="one_f">
              <div class="one_the">{{ items7[hhh].title }}</div>
              <div
                v-for="(iteme, j) in items7[hhh].conments"
                :key="j"
                class="one_g animate__animated animate__bounceInUp"
              >
                <img src="../assets/HelloWorld/xiaoyuanqiu_1.png" alt="" />
                <div>{{ iteme }}</div>
              </div>
       <a href="/projectE">
                <div class="boss_1">
                  <div>了解更多</div>
                  <i class="el-icon-arrow-right" style="font-size: 20px;"></i>

                </div>
              </a>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <ChildComponent :is-open="isOpen" @update:isOpen="handleUpdate" />
    <Dialog :visible.sync="visible"  @update:visible="visible = $event">
    </Dialog>
  </div>
</template>

<script>
import Dialog  from '@/components/components/diolog.vue';
import ChildComponent  from '@/components/components/DialogComponent.vue'

export default {
  name: "schemeTop",
  components: {
    Dialog ,
    ChildComponent  

  },
  data() {
    return {
      isOpen: false ,

      items2: [
        {
          title: "专属教务管理",
          conments: [
            "连接人才培养、晋升、招聘等环节闭环",
            "打造数字化人才管理，告别低效线下管理体系",
            "形成有效的岗位专业+高匹配度人才梯度",
          ],
        },
        {
          title: "教培特定场景应用",
          conments: [
            "一站式、无纸化、线上化全流程企业培训",
            "打破空间、时间限制，节省差旅等培训成本",
            "培训项目碎片化管理，模板沉淀方便复用",
          ],
        },
        {
          title: "数据管理沉淀",
          conments: [
            "线上学习+阶段性考核，强化内容吸收",
            "实践应用专题研讨，强化学习交流",
            "实践案例快速沉淀，学习项目不断精进",
          ],
        }
      ],
      items3: [
        {
          title: "OMO混合式学习",
          conments: [
            "多种学习方式组合",
            "培训场景化、游戏化、互动性",
            "支持线上、线下融合的学习路径",
          ],
        },
        {
          title: "在线智能考试",
          conments: [
            "以考促学，以练代培",
            "支持多种题型，智能阅卷，高效考试配置能力",
            "灵活解决复杂考试场景，搭建测、练、考一体化系统。",
          ],
        },
        {
          title: "可视化数据呈现",
          conments: [
            "直观学习时长、培训频次、参与度、正确率等数据分析结果，快速掌握学习情况",
            "管理者随时可进入培训课堂，合理化过程监控",
            "量化学习效果，辅助科学分析和培训管理，保障结果。",
          ],
        },
        {
          title: "多种形式培训方式",
          conments: [
            "支持直播、录播等多种形式进行培训",
            "丰富互动工具、打卡签到功能，积分、学分双修",
            "课程内容云端存储，便于复习和资源复用。",
          ],
        },
        {
          title: "巩固测评提升效果",
          conments: [
            "培训前-中-后，快速获取学习数据，数据一体化沉淀",
            "指定时间专岗测评，“机考”方式让培训质量反馈更精准",
            "真实数据，为管理者提供运营参考，更便于制定人才提升计划。",
          ],
        },
      ],
      items4: [
        {
          title: "营运能力培养提升",
          conments: [
            "客户全方位数字化学习运营服务学习",
            "项目体系搭建、运营、数据分析、运营建议、运营服务等多方面能力培养",
            "专业服务，能力提升，不断储备专业型人才。",
          ],
        },
        {
          title: "直播电商实战训练营",
          conments: [
            "帮助店长理解新零售转型过程中，角色和能力转变",
            "学习场景式，体验式营销，规划品类及精细管理，提升客流量和成交率",
            "帮助店长掌握新渠道开源，线上线下OMO融合运营，数据化挖掘计划，提升业绩。",
          ],
        },
        {
          title: "店长能力专项提升",
          conments: [
            "规模化店长能力培养，个性化店长养成",
            "构建标准化晋升梯度管理机制，让人才希望倍增",
            "盘点店长培训效果，实现人才培养调度中心，提升管理水平。",
          ],
        },
      ],
      items5: [
        {
          title: "一站式培训平台",
          conments: [
            "便捷式培训权限管理机制，满足严谨体系化集团管理",
            "银行级数据安全防护，信息安全有保障",
            "可视化、标准化的岗位发展体系，针对性知识学习",
            "多端API接口，可实现多业务平台数据打通。",
          ],
        },
        {
          title: "人才梯队建设",
          conments: [
            "可视化的人才发展路径，为员工提供清晰的发展路径",
            "远程培训，按阶段设置学习任务，提高成长速度",
            "员工端社区式沟通、积分制管理，增强员工归属",
            "岗位与课程标签匹配，真正实现能力精准提升。",
          ],
        },
        {
          title: "全程学习追踪",
          conments: [
            "一站式、无纸化、线上化全流程企业培训",
            "打破空间、时间限制，节省差旅等培训成本",
            "培训项目轻松管理，模板沉淀方便复用",
            "训前评测，深度解析员工能力，训后评估，能力成长清晰可视。",
          ],
        },
        {
          title: "多样化学习方式",
          conments: [
            "线上学习+阶段性考核，强化内容吸收",
            "实践应用专题研讨，强化学习交流",
            "实践案例快速沉淀，学习项目不断精进",
            "碎片化学习，多端学习端口一键触达，让学习简单化。",
          ],
        },
      ],
      items6: [
        {
          title: "体系化促进能力提升",
          conments: [
            "搭建岗位晋级发展通道，满足人才长期发展需求",
            "直播工具助力跨区域人员分享交流、培训赋能",
            "外采精选知识萃取、专业性课程自研，形成高效知识库。",
          ],
        },
        {
          title: "专业赋能促进效率提升",
          conments: [
            "测学练考评，多种手段保障生产赋能效果",
            "培训全员质量+服务意识，支撑全面优质管理体系落地",
            "助力精细化经营管理落地，有效提高质量管理效果。",
          ],
        },
        {
          title: "聚焦核心岗位/推动营销升级",
          conments: [
            "解锁卓越服务标兵精进模式",
            "打通全通道进阶晋升之路",
            "新生代能力重构，打造专业服务能力。",
          ],
        },
      ],
      items7: [
        {
          title: "形式升级",
          conments: [
            "搭建岗位晋级发展通道，满足人才长期发展需求",
            "直播工具助力跨区域人员分享交流、培训赋能",
            "外采精选知识萃取、专业性课程自研，形成高效知识库。",
          ],
        },
        {
          title: "过程监督",
          conments: [
            "测学练考评，多种手段保障生产赋能效果",
            "培训全员质量+服务意识，支撑全面优质管理体系落地",
            "助力精细化经营管理落地，有效提高质量管理效果。",
          ],
        },
        {
          title: "效果考核与分析",
          conments: [
            "解锁卓越服务标兵精进模式",
            "打通全通道进阶晋升之路",
            "新生代能力重构，打造专业服务能力。",
          ],
        },
      ],
      activeName: "1",
      visible: false,
      hhh: 0,
    }
  },
  mounted() {},
  methods: {
    handleUpdate(newVal) {  
      this.isOpen = newVal; // 接收到子组件传递的新的 isOpen 值，更新父组件的 isOpen 状态  
      // 其他逻辑...  
    }  ,
    // visibleTOP(){
    //   this.$router.p
    // },
    handleClick(tab, event) {
      this.hhh = 0
    },
    qiehuanTop(i) {
      this.hhh = i
    },
  },
}
</script>

<style lang="scss" scoped>
a{
  color: #ffffff;
  text-decoration: none;
}
.one_d:hover,.one_ok:hover {
    cursor:pointer;
  }
.one_a {
  height: 476px;
  display: flex;
  justify-content: center;
  animation-duration:1s;
}
::v-deep .el-tabs__content{
  width: 7000px;
}
::v-deep .el-tabs--top{
  display: flex;
    flex-direction: column;
    align-items: center;
}
.boss_a {
  background: url("../assets/HelloWorld/It_1.png");
  background-size: 60%;
  background-repeat: no-repeat;
}
.boss_b {
  background: url("../assets/HelloWorld/It_2.png");
  background-size: 60%;
  background-repeat: no-repeat;
}
.boss_c {
  background: url("../assets/HelloWorld/IT_3.png");
  background-size: 60%;
  background-repeat: no-repeat;
}
.boss_d {
  background: url("../assets/HelloWorld/it_4.png");
  background-size: 60%;
  background-repeat: no-repeat;
}
.boss_e {
  background: url("../assets/HelloWorld/it_5.png");
  background-size: 60%;
  background-repeat: no-repeat;
}
.boss_f {
  background: url("../assets/HelloWorld/IT_6.png");
  background-size: 60%;
  background-repeat: no-repeat;
}

::-webkit-scrollbar {
  display: none;
}
.one_b {
  height: 316px;
  padding: 80px 0 0 0;
  display: flex;

  .one_c {
    width: 260px;
    margin-right: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .one_hh {
      div:last-child {
        margin-bottom: 0;
      }
      max-height: 180px;
      overflow-y: auto;
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      box-sizing: border-box;
  
      .one_d {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 0 0 24px;
        line-height: 40px;
        color: #ffffff;
        margin-bottom: 12px;
        font-size: 20px;
        font-weight: 500;
        border-left: 2px solid transparent;
        box-sizing: border-box;
        &.active {
          background: rgba(255, 255, 255, 0.3);
          border-left: 2px solid #ffffff;
          box-sizing: border-box;
        }
      }
    }
    .one_ok {
      width: 112px;
      height: 44px;
      border-radius: 2px 2px 2px 2px;
      opacity: 1;
      cursor: pointer;
      border: 1px solid #ffffff;
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
    }
  }
  .one_e {
    width: 900px;
    background: #f5f5f6;
    .one_f {
      padding: 30px 60px;
      height: 256px;
      position: relative;
      /* overflow-y: auto; */
      .one_the {
        font-size: 24px;
        font-weight: 600;
        line-height: 50px;
        margin-bottom: 6px;
      }
      .one_g {
        display: flex;
        height: 50px;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
        div {
          font-size: 20px;
          font-weight: 400;
          color: #000000;
        }
      }
    }
  }
}
.boss_1{
  position: absolute;
  top: 40px;
  right: 20px;
display: flex;
color: #9A9A9A  ;

// border: 1px solid #eb5b05;
padding: 3px 0 5px 20px;
justify-content: center;
align-items: center;
cursor: pointer; //变手
// img{
//   width: 40px;
// }
div{
  margin: 0 4px 0 0;
  // color: #000000;
  font-size: 18px;
}
}
.hello {
  /* width: 1200px; */
  /* padding: 0 120px; */
  min-height: 710px;
  .helloTop {
    // height: 136px;
    .helloTopOne {
      height: 56px;
      text-align: center;
      // padding: 80px 0 0;
      font-size: 40px;
      font-weight: 500;
      color: #121221;
    }
  }
}
.oneTwo ::v-deep .el-tabs__item {
  height: 28px !important;
  line-height: 28px !important;
  font-size: 20px;
  font-weight: 500;
  color: #121221;
  width: 120px;
  text-align: center;
}
/* .oneTwo ::v-deep .el-carousel__indicators--outside {
  display: none;
} */
.oneTwo ::v-deep .el-tabs__nav {
  height: 45px;
  padding-top: 30px;
}
.oneTwo ::v-deep .el-tabs__item:hover {
  color: #eb5b05;
}
.oneTwo ::v-deep .el-tabs__item.is-active {
  color: #eb5b05;
}
.oneTwo ::v-deep .el-tabs__active-bar {
  background: #eb5b05;
}
.oneTwo ::v-deep .el-tabs__header {
  margin: 0;
  padding: 0 120px 20px;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}





</style>
